import { render, staticRenderFns } from "./AdminBookingsMenu.vue?vue&type=template&id=a96dcf18"
import script from "./AdminBookingsMenu.vue?vue&type=script&lang=js"
export * from "./AdminBookingsMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports